import React from 'react';
import fallbackPortrait from '../../assets/author2.jpg';
import { useContent } from '../../context/ContentContext';
import { withExternalLinks } from '../../utils/richText';
import './About.css';

const About = () => {
  const { siteContent, siteImages } = useContent();

  return (
    <div className="about">
      <div className="ltr">
        <img
          className="about-img"
          src={siteImages.about_image || fallbackPortrait}
          alt="gauri-awasthi"
        />
        <div className="about-content">
          <h2>{siteContent.about_heading}</h2>
          <div
            className="about-text"
            dangerouslySetInnerHTML={{ __html: withExternalLinks(siteContent.about_bio_html) }}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
